/**
 * @flow
 */

import React, { PureComponent } from 'react'
import * as animationData from './animationData.json'

let MyWindowDependentLibrary = null
if (
  typeof window !== 'undefined' &&
  typeof window.navigator !== 'undefined' &&
  typeof document !== 'undefined'
) {
  // eslint-disable-next-line
  MyWindowDependentLibrary = require('react-lottie').default
}

class DefaultLoader extends PureComponent {
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData
    }
    return (
      MyWindowDependentLibrary && (
        <MyWindowDependentLibrary
          options={defaultOptions}
          height={44}
          width={44}
        />
      )
    )
  }
}

export default DefaultLoader



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/DefaultLoader/index.js